import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  showMoreMessage: {
    defaultMessage: `Show more`,
    description: 'Label for show more button to show more',
    id: 'townsquare.pagination.show-more-button.button-text',
  },
});
